<template>
  <div class="new-style">
    <div class="block" @click="goBannerDetail(70)">
      <!-- <span class="demonstration">默认 Hover 指示器触发</span> -->
      <el-carousel height="168px" arrow="never">
        <el-carousel-item v-for="item in images" :key="item.id">
          <img :src="item.path" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="logo-content">
      <div @click="goHome()" class="home">
        <img src="@/assets/images/logo.png" alt="" />
      </div>
    </div>
    <div class="menu">
      <el-menu ref="menu" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#fff"
        text-color="#000000" active-text-color="#206BD1">
        <el-menu-item index="1" @click="home()">首页</el-menu-item>
        <el-submenu index="2" popper-class="test new-style-popper">
          <template slot="title"><span @click="jtjj()">集团介绍</span></template>
          <el-menu-item index="2-1"><span @click="jtjj()">集团简介</span></el-menu-item>
          <el-menu-item index="2-2" @click="zzjg()">组织架构</el-menu-item>
          <el-menu-item index="2-3" @click="jtwh()">集团文化</el-menu-item>
          <el-menu-item index="2-4" @click="lxwm()">联系我们</el-menu-item>
        </el-submenu>
        <el-menu-item index="3" @click="jlzx()">津旅资讯</el-menu-item>
        <el-submenu index="4" popper-class="test new-style-popper">
          <template slot="title"><span @click="gqdj()"> 国企党建</span></template>
          <el-menu-item v-for="(item, index) in gqdjList" :key="index" :index="item.id" @click="goGqdj(item)">{{
            item.name
            }}</el-menu-item>
          <!-- <el-menu-item index="4-1" @click="djgz()">党建工作</el-menu-item> -->
          <!-- <el-menu-item index="4-2" @click="xxyd()">学习园地</el-menu-item> -->
        </el-submenu>
        <el-submenu index="5" popper-class="test new-style-popper">
          <template slot="title"><span @click="jlpp()">津旅品牌</span></template>
          <el-submenu index="5-1">
            <template slot="title">
              <div @click="jdbk()">酒店板块</div>
            </template>
            <el-menu-item index="5-1-1"><span @click="lsddfd()">利顺德大饭店</span></el-menu-item>
            <el-menu-item index="5-1-2"><span @click="yygj()">燕园国际大酒店</span></el-menu-item>
            <el-menu-item index="5-1-3"><span @click="yybg()">友谊宾馆</span></el-menu-item>
            <el-menu-item index="5-1-4"><span @click="tjgwy()"> 天津港旅物业...</span></el-menu-item>
            <el-menu-item index="5-1-5"><span @click="lsdds()">利顺德大厦</span></el-menu-item>
          </el-submenu>
          <el-submenu index="5-2">
            <template slot="title">
              <div @click="lybk()">旅游板块</div>
            </template>
            <el-menu-item index="5-2-1"><span @click="jsjt()">津食集团</span></el-menu-item>
            <el-menu-item index="5-2-2"><span @click="tjgl()">天津国旅</span></el-menu-item>
            <el-menu-item index="5-2-3"><span @click="hhyc()">海河游船公司</span></el-menu-item>
            <el-menu-item index="5-2-4"><span @click="jlsw()">津旅商务</span></el-menu-item>
            <el-menu-item index="5-2-5"><span @click="gzzx()">国展中心</span></el-menu-item>
          </el-submenu>
          <el-submenu index="5-3">
            <template slot="title">
              <div @click="zhpt()">综合配套板块</div>
            </template>
            <el-menu-item index="5-3-1"><span @click="lyqc()">旅游汽车公司</span></el-menu-item>
            <el-menu-item index="5-3-2"><span @click="jlwy()">津旅物业</span></el-menu-item>
            <el-menu-item index="5-3-3"><span @click="bfrc()">北方人才港</span></el-menu-item>
            <el-menu-item index="5-3-4"><span @click="xyjck()">新远进出口</span></el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-submenu index="6" popper-class="test new-style-popper">
          <template slot="title"><span @click="xxgk">信息公开</span></template>
          <el-menu-item v-for="(item, index) in xxgkList" :key="index" :index="`6-${item.menuId.toString()}`"
            @click="goXxgk(item.menuId)">{{ item.name }}</el-menu-item>
        </el-submenu>
        <el-submenu index="7" popper-class="test new-style-popper">
          <template slot="title"><span @click="pxfz">人才引进</span></template>
          <el-menu-item index="7-1" @click="pxfz">培训发展</el-menu-item>
          <el-menu-item index="7-2" @click="gzjh">工作机会</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      images: [
        { id: 1, url: require("@/assets/images/1.png"), qq: "水电费水电费" },
        { id: 2, url: require("@/assets/images/2.png"), qq: "而威尔" },
        { id: 3, url: require("@/assets/images/4.png"), qq: "水电费是的" },
      ],
      xxgkList: [],
      gqdjList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getFicarousel();
    this.getMenus();
  },
  mounted() {
    this.$refs.menu.activeIndex = this.$route.meta.index
  },
  beforeDestroy() { },
  methods: {
    goXxgk(id) {
      this.$router.push("/xxgk?index1=" + id);
    },
    getFicarousel() {
      axios.get("/jtg/home/ficarousel").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.images = res.data;
        // console.log(res);
      });
    },
    goBannerDetail(id) {
      let params = {
        pageNum: 1,
        pageSize: 10,
        menuId: id,
      };
      axios.get("/jtg/home/articleList", { params }).then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        let ldId = res.data.items[0].id;

        this.$router.push("/bannerDetail?index=" + ldId);
      });
    },
    getMenus() {
      axios.get("/jtg/home/menus").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        res.data.forEach((item) => {
          if (item.state !== 1) {
            return;
          }

          if (item.dictLabel == "信息公开" && item.name != "信息公开") {
            this.xxgkList.push(item);
          }
          if (item.dictLabel == "国企党建" && item.name != "国企党建") {
            this.gqdjList.push(item);
          }
        });

        if (this.$route.meta.index === "6") {
          this.$refs.menu.activeIndex = `6-${this.xxgkList[0].menuId}`
        }
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    goHome() {
      this.$router.push("/");
    },
    xxgk() {
      this.$router.push("/xxgk?index1=" + 7);
    },
    jtjj() {
      this.$router.push("/jtjs?index1=" + 1);
    },
    zzjg() {
      this.$router.push("/jtjs?index1=" + 2);
    },
    jtwh() {
      this.$router.push("/jtjs?index1=" + 3);
    },
    lxwm() {
      this.$router.push("/jtjs?index1=" + 4);
    },
    home() {
      this.$router.push("/");
    },
    jlzx() {
      this.$router.push("/jlzx");
    },
    onHover() {
      this.radio1 = "overview";
    },
    onHover1() {
      this.radio1 = "upgrade";
    },
    onHover2() {
      this.radio1 = "version";
    },
    gqdj() {
      this.$router.push("/gqdj?index1=" + 5);
    },

    xxyd() {
      this.$router.push("/gqdj?index1=" + 2);
    },
    goGqdj(item) {
      console.log(item, 77777);
      this.$router.push("/gqdj?index1=" + item.menuId);
      // if(item.name=='党建工作'){
      //   this.$router.push("/gqdj?index1=" + 1);
      // }else if(item.name=='学习')
    },
    djgz() {
      this.$router.push("/gqdj?index1=" + 1);
    },
    pxfz() {
      this.$router.push("/rcyj?index1=" + 1);
    },
    gzjh() {
      this.$router.push("/rcyj?index1=" + 2);
    },
    jlpp() {
      this.$router.push("/jlpp?index1=" + "jlpp");
    },
    jdbk() {
      this.$router.push("/jlpp?index1=" + "jdbk");
    },
    lsddfd() {
      this.$router.push("/jlpp?index1=" + 2);
    },
    yygj() {
      this.$router.push("/jlpp?index1=" + 3);
    },
    yybg() {
      this.$router.push("/jlpp?index1=" + 4);
    },
    tjgwy() {
      this.$router.push("/jlpp?index1=" + 5);
    },
    lsdds() {
      this.$router.push("/jlpp?index1=" + 6);
    },
    lybk() {
      this.$router.push("/jlpp?index1=" + "lybk");
    },
    jsjt() {
      this.$router.push("/jlpp?index1=" + 7);
    },
    tjgl() {
      this.$router.push("/jlpp?index1=" + 8);
    },
    hhyc() {
      this.$router.push("/jlpp?index1=" + 9);
    },
    jlsw() {
      this.$router.push("/jlpp?index1=" + 10);
    },
    gzzx() {
      this.$router.push("/jlpp?index1=" + 11);
    },
    zhpt() {
      this.$router.push("/jlpp?index1=" + "zhpt");
    },
    lyqc() {
      this.$router.push("/jlpp?index1=" + 12);
    },
    jlwy() {
      this.$router.push("/jlpp?index1=" + 13);
    },
    bfrc() {
      this.$router.push("/jlpp?index1=" + 14);
    },
    xyjck() {
      this.$router.push("/jlpp?index1=" + 15);
    },
  },
};
</script>
<style lang='scss' scoped>
.el-menu.el-menu--horizontal {
  display: flex;
  justify-content: center;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
  font-size: 16px;
  width: 180px;
  text-align: center;
}

.el-menu--horizontal>.el-menu-item:first-child {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.el-menu-item {
  width: 180px;
  text-align: center;
}

.el-menu--popup .el-menu-item {
  min-width: 0px !important;
}

.el-menu--popup .el-menu-item:hover {
  border-left: 0px !important;
}

::v-deep .el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #fff !important;
}

.logo-content {
  display: flex;
  justify-content: flex-start;
  margin-left: 350px;
}

.home {
  cursor: pointer;
}

.test1 {
  background-color: #fff !important;
  color: #004aba !important;
  font-weight: 400;
  width: 200px;
  height: 100%;
  font-size: 16px;
  margin: 9px -10px;
  text-align: center;
}

.test {
  border: none !important;

  .el-menu {
    width: 180px;
    background-color: rgba(255, 255, 255, 0.85) !important;

    .el-menu-item {
      background-color: #fff !important;
      color: #004aba !important;
      font-weight: 400;
      width: 90%;
      height: 30px !important;
      font-size: 16px;
      margin: 5px 9px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
// 这css完全没法改，一个logo-content居然有31个，其中还有五个在相互覆盖
// 样式在这里进行覆盖，以前的css不能动
.new-style {
  .logo-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 112px;
    border-bottom: 2px solid #edeff2;
    background-color: rgb(245, 247, 250);
    margin: 0;
  }

  ::v-deep .el-menu-demo {
    display: flex;
    justify-content: center;
    border-bottom: 0 !important;
    height: 128px;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 8px;
      background: #BFC5CC;
      z-index: 1;
    }

    .el-menu-item,
    .el-submenu .el-submenu__title {
      position: relative;
      width: 160px;
      height: 128px;
      line-height: 110px;
      border-bottom: 8px solid transparent;
      background-color: transparent !important; // 强制盖住Hover样式
      transition: all 0.3s ease !important;

      &,
      span {
        font-size: 24px !important;
      }
    }

    .el-menu-item.is-active,
    .el-menu-item:hover,
    .el-submenu.is-active .el-submenu__title,
    .el-submenu:hover .el-submenu__title {
      border-bottom: 8px solid #206bd1 !important;
      z-index: 2;
      color: #206bd1 !important;
      font-weight: bold;

      .el-submenu__icon-arrow {
        color: #206bd1;
      }
    }

    .el-submenu .el-submenu__icon-arrow {
      position: absolute;
      width: 16px;
      font-size: 16px;
      font-weight: bold;
      margin: 0 0 0 -8px;
      left: 50%;
      top: auto;
      bottom: 12px;
    }
  }

}
</style>
<style lang="scss">
// 样式在这里进行覆盖，以前的css不能动
.new-style-popper.test {
  .el-menu--popup {
    border-radius: 8px;
    border: 0 !important;
  }

  &>.el-menu {
    margin-left: -30px;
  }

  .el-menu {
    width: 220px;
    margin-top: 0;
    padding: 6px 0 !important;
    background-color: #FFFFFF66 !important;

    .el-submenu {
      width: 100%;
      text-align: center;

      span {
        display: inline-block;
        width: 100%;
        text-align: center;
      }
    }

    &.el-menu--popup {

      .el-menu-item,
      .el-submenu__title {
        font-size: 16px;
        margin: 6px 23px;
        height: 40px !important;
        line-height: 40px !important;
        border-radius: 60px;
        color: #000 !important;
        border-left: 0 !important;
      }
    }
  }

  .el-submenu__icon-arrow {
    right: 10px;
    top: 0;
    line-height: 40px !important;
    margin: 0 !important;
  }

  .el-submenu .el-submenu__title:hover,
  .el-menu--popup .el-menu-item:not(.is-disabled):hover {
    background: #206bd1 !important;
    color: #fff !important;

    .el-submenu__icon-arrow {
      color: #fff !important;
    }
  }
}
</style>
